module.exports = {
  "id": "63b0e76c-d3bc-4b08-8915-baa9c419f599",
  "gtmIds": [
    "GTM-NRDZNSKX",
    "GTM-PNKMWZJH"
  ],
  "hasInAppVersion": true,
  "group": "Gulf Islands Waterpark",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "languages": [
    "en-US",
    "es-MX"
  ],
  "website": "https://www.gulfislandswaterpark.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}